import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layouts/Header";
// import ReactLanguageSelect from "react-languages-select";
// import "react-languages-select/css/react-languages-select.css";
// import { Translate } from "@google-cloud/translate";
import { BsChevronDown } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import {
  FetchCompany,
  FetchScreenname,
  createTranslation,
  fetchLanguages,
  fetchRoleModule,
  fetchTranslationData,
  updateTranslationData,
} from "../../redux/actions/action";
// import Header from "../../components/Header";
import trans_icon from "../../assets/icons/icon_set.svg";
import alllanguages from "../../utils/lang/languagesofworld.json";
// import userIcon from "../../assets/icons/userroleicon.svg";
// import arrowIcon from "../../assets/icons/arrow.svg";
// import setting from "../../assets/icons/setting-menu.svg"
// import
//   fetchRoleList,
//   createTranslation,
//   fetchRoleModule,
//   updateRoleModule,
//   fetchScreenname,
//   fetchTranslationData,
//   FetchLanguages,
//   updateTranslationData,
// "../../redux/actions/action";
// import "../../styles/local/roleassign.css";
import { Col, Row } from "react-bootstrap";
import InfoSaveOrNotPopup from "../../components/Dailogs/InfoSaveOrNotPopup";
import "../../assets/styles/local/settings.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
// import { Warningpopup } from "./Warningpopup";
// import PopupWarn from "../../components/dialogs/PopupWarn";

const Settings = () => {
  const userId = window.localStorage.getItem("userid");
  const roleId1 = window.localStorage.getItem("roleid");
  const companyname = window.localStorage.getItem("companyname");
  const companyID = window.localStorage.getItem("companyid");
  const languages = window.localStorage.getItem("language");
  let now = new Date();
  let options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    // hour: '2-digit',
    // minute: '2-digit'
  };
  const dispatch = useDispatch();
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [showStatusDrop2, setShowStatusDrop2] = useState(false);
  const [showStatusDrop4, setShowStatusDrop4] = useState(false);
  const [showStatusDrop3, setShowStatusDrop3] = useState(false);
  const [showMemberItem, setShowMemberItem] = useState(false);
  const [closeone, setCloseone] = useState(false);
  const hasSelectedInitialModule = useRef(false);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [popups, setPopups] = useState(false);
  const [warn, setWarn] = useState(false);
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState(" Translations Updated Successfully");
  const [msges, setMsges] = useState(
    "Would you like to cancel changes or come back to editing?",
  );
  const [comp, setComp] = useState("");
  const [changeComp, setChangeComp] = useState("");
  const [searchlang, setSearchlang] = useState("");
  const [relationship, setRelationship] = useState("");
  const [createdlangnames, setCreatedlangnames] = useState("");
  const [serchlanguagesList, setSearchLanguagesList] = useState([]);
  const [iconn, setIconn] = useState(true);

  const [fetchTransSettingList, setFetchTransSettingList] = useState([]);
  const [touched, setTouched] = useState(false);
  const history = useHistory();
  const fetchScreennameData = useSelector(
    (state) => state.user.FetchScreenList,
  );
  const fetchTranslationDatas = useSelector(
    (state) => state.user.FetchTranslationList,
  );
  const FetchLanguagesData = useSelector(
    (state) => state.user.FetchlanguagesList,
  );
  const FetchCompanyData = useSelector((state) => state.user.FetchCompanyList);
  const updateTranslationDataRes = useSelector(
    (state) => state.user.updateTranslationDataList,
  );
  const createTranslationresponse = useSelector(
    (state) => state.user.FetchCreatetranslist,
  );
  const rolesModuleList = useSelector((state) => state.user.roleModuleData);
  const [fetchModuleList, setFetchModuleList] = useState([]);
  const [fetchModulemainList, setFetchModulemainList] = useState([]);
  const [fetchLanguageList, setFetchLanguageList] = useState([]);
  const [fetchTransList, setFetchTransList] = useState([]);
  const [fetchCompanyList, setFetchCompanyList] = useState([]);
  const [moduleName, setModuleName] = useState("");
  const [modulemainName, setModulemainName] = useState("");
  const [modulescreenName, setModulescreenName] = useState("");
  const [langHad, setLangHad] = useState(languages || "");
  const [companyid, setCompanyid] = useState("");
  const [transName, setTransName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [language, setLang] = useState([]);
  const [paddingCol, setPaddingCol] = useState(true);

  const [reRenderTranslate, setReRenderTranslate] = useState(false);

  const [showAdditionalSetting, setShowAdditionalSetting] = useState(false);
  const [screenTranslations, setScreenTranslations] = useState({});
  const t = (key) => screenTranslations?.[key] || "";

  useEffect(() => {
    if (!langHad || !modulescreenName) return;

    setCurrentPage(0);
    setPerPage(10);
    setShowAdditionalSetting(true);
    dispatch(fetchTranslationData(langHad, modulescreenName, companyID));
  }, [langHad, modulescreenName, companyID, dispatch]);

  useEffect(() => {
    dispatch(FetchCompany());
    dispatch(fetchLanguages());
    dispatch(fetchRoleModule(roleId1));
    // dispatch(fetchRoleList());
    // dispatch(FetchLanguages());
    // setLang(lang.english[0].roleAssign);
    fetchScreenTranslations("Translation").then((res) => {
      setScreenTranslations(res);
    });
  }, []);

  useEffect(() => {
    if (updateTranslationDataRes?.data?.status == true) {
      dispatch(FetchCompany());
    }
  }, [updateTranslationDataRes]);

  useEffect(() => {
    fetchScreenTranslations("Translation").then((res) => {
      setScreenTranslations(res);
    });
  }, [reRenderTranslate]); // Or [] if effect doesn't need props or state

  React.useEffect(() => {
    setSearchLanguagesList(alllanguages.languages);
  }, []);

  React.useEffect(() => {
    if (fetchScreennameData?.data?.status == true) {
      const screens = fetchScreennameData?.data?.data || [];
      setFetchModuleList(screens);
      setModulescreenName(screens[0]?.screenname || "");
    }
  }, [fetchScreennameData]);

  React.useEffect(() => {
    if (FetchCompanyData?.data?.status == true) {
      setFetchCompanyList(FetchCompanyData?.data?.data);
    }
  }, [FetchCompanyData]);
  ////peggination/////////////////////////
  useEffect(() => {
    fetchMemberList();
  }, [currentPage, query]);
  const fetchMemberList = () => {
    if (query) {
      // dispatch(FetchUsersByCompany(companyid, 0, 0));
    } else {
      // dispatch(FetchUsersByCompany(companyid, perPage, currentPage + 1));
    }
  };
  useEffect(() => {
    if (currentPage == 0) {
      fetchMemberList();
    } else {
      // setCurrentPage(0);
    }
  }, [perPage]);
  const preparePagination = (totalRecords) => {
    const totalPages = Math.ceil(totalRecords / perPage);
    setTotalPages(totalPages);
  };
  React.useEffect(() => {
    if (rolesModuleList?.status == true) {
      const modules = rolesModuleList?.data || [];
      setFetchModulemainList(modules);
      if (!hasSelectedInitialModule.current && modules.length > 0) {
        hasSelectedInitialModule.current = true;
        setModulemainName(modules[0].modulename);
        setModulescreenName("");
        setFetchModuleList([]);
        dispatch(FetchScreenname(modules[0].moduleid));
      }
    }
  }, [rolesModuleList, dispatch]);

  React.useEffect(() => {
    if (fetchTranslationDatas?.status == 200) {
      // setFetchTransList(fetchTranslationDatas?.data?.data);
      preparePagination(fetchTranslationDatas?.data?.data?.length);
      if (query) {
        let tempMembers = [...fetchTranslationDatas?.data?.data];
        tempMembers = tempMembers?.filter((list) => {
          return (
            list?.fieldname?.toLowerCase().includes(query.toLowerCase()) ||
            list?.translation?.toLowerCase().includes(query.toLowerCase())
          );
        });
        setFetchTransList(
          tempMembers?.slice(currentPage * 10, (currentPage + 1) * 10),
        );
        // setFetchModulemainList(tempMembers);
      } else {
        // setFetchTransList(fetchTranslationDatas?.data?.data);

        let tempPaginationObj = {
          records: fetchTranslationDatas?.data?.data?.slice(
            currentPage * 10,
            (currentPage + 1) * 10,
          ),
        };
        setFetchTransList(tempPaginationObj?.records);
      }
    }
  }, [fetchTranslationDatas, query]);

  React.useEffect(() => {
    if (FetchLanguagesData?.data?.status == true) {
      setFetchLanguageList(FetchLanguagesData?.data?.data);
    }
  }, [FetchLanguagesData]);

  //   React.useEffect(() => {
  //     if (updateTranslationDataRes.status == true) {

  //       setFetchTransList([]);
  //       setWarn(true);
  //       setPaddingCol(true);
  //       setTimeout(() => {
  //         setWarn(false);
  //       }, 10000);
  //     }
  //   }, [updateTranslationDataRes]);

  React.useEffect(() => {
    if (createTranslationresponse.status == 200) {
      dispatch(fetchTranslationData(createdlangnames, modulescreenName));
      dispatch(fetchLanguages());
    }
  }, [createTranslationresponse]);

  // useEffect(() => {
  //   const translate = new Translate();
  //   async function fetchLanguages() {
  //     try {
  //       const [languages] = await translate.getLanguages();
  //       setSearchLanguages(languages);
  //     } catch (error) {
  //       console.error("Error fetching languages:", error);
  //     }
  //   }

  //   fetchLanguages();
  // }, []);

  const filteredLanguages = serchlanguagesList.filter((language) =>
    language.name.toLowerCase().includes(searchlang.toLowerCase()),
  );

  const PaginationChange = (event) => {
    setCurrentPage(event.selected);
    let tempPaginationObj = {
      records: fetchTranslationDatas?.data?.data?.slice(
        event.selected * perPage,
        (event.selected + 1) * perPage,
      ),
    };
    setFetchTransList(tempPaginationObj?.records);
  };

  const [storedTranslation, setStoredTranslation] = useState([]);
  console.log("asc332", storedTranslation);

  const handleInputChange = (e, id) => {
    // setChangeComp(e.target.value);
    const reqIndex = fetchTransList.findIndex(
      (item) => item.translationid === id,
    );
    setFetchTransList((prev) => [
      ...prev.slice(0, reqIndex),
      {
        ...prev[reqIndex],
        translation: e.target.value,
      },
      ...prev.slice(reqIndex + 1),
    ]);
    // setInputValue(event.target.value);

    setStoredTranslation((prevAsc) => {
      const newAsc = [...prevAsc];
      const index = newAsc.findIndex((item) => item.translationid === id);

      if (index !== -1) {
        // Update existing item
        newAsc[index] = { ...newAsc[index], translation: e.target.value };
      } else {
        // Add new item if not found
        newAsc.push({
          translationid: id,
          translation: e.target.value,
        });
      }

      return newAsc;
    });
  };

  const updateTextareaHeight = (element) => {
    element.style.height = "auto";
    element.style.height = element.scrollHeight + "px";
  };

  const handleUpdate = () => {
    // dispatch(updateTranslationData(langHad, modulescreenName, fetchTransList));
    dispatch(
      updateTranslationData(langHad, modulescreenName, storedTranslation),
    );
    setModuleName("");
    setLangHad("");
    setModulemainName("");
    setModulescreenName("");
    setCloseone(false);
    setCurrentPage(0);
    setTimeout(() => {
      setReRenderTranslate(!reRenderTranslate);
    }, 2000);
  };

  const handelCancels = () => {
    dispatch(FetchCompany());

    if (changeComp !== "") {
      setPopups(true);
    } else {
      setFetchTransList([]);
      setModuleName("");
      setModulemainName("");
      setLangHad("");
      setModulescreenName("");
    }
  };

  const refTypeDropDownContainer = useRef();
  const refTypeDropDownContainerExclude = useRef();
  const refTypeDropDownContainer1 = useRef();
  const refTypeDropDownContainer1Exclude = useRef();
  const refTypeDropDownContainer2 = useRef();
  const refTypeDropDownContainer2Exclude = useRef();
  const refTypeDropDownContainer3 = useRef();
  const refTypeDropDownContainer3Exclude = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer.current &&
      !refTypeDropDownContainer.current.contains(event.target) &&
      !refTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowStatusDrop(false);
    }
    if (
      refTypeDropDownContainer1.current &&
      !refTypeDropDownContainer1.current.contains(event.target) &&
      !refTypeDropDownContainer1Exclude.current.contains(event.target)
    ) {
      setShowStatusDrop2(false);
    }

    if (
      refTypeDropDownContainer2.current &&
      !refTypeDropDownContainer2.current.contains(event.target) &&
      !refTypeDropDownContainer2Exclude.current.contains(event.target)
    ) {
      setShowStatusDrop3(false);
    }
    if (
      refTypeDropDownContainer3.current &&
      !refTypeDropDownContainer3.current.contains(event.target) &&
      !refTypeDropDownContainer3Exclude.current.contains(event.target)
    ) {
      setShowStatusDrop4(false);
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleMouseDowTypeDD);

    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, [showStatusDrop]);

  // const fetchCompanyStatus = async (targeted) => {
  //   await axios({
  //     method: "post",
  //     url: `//translation.googleapis.com/language/translate/v2/languages`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: {},
  //   }).then((response) => {
  //     // setSuggestionlang(response.data);

  //   });
  // };

  // React.useEffect(() => {
  //   fetchCompanyStatus("zh-TW");
  // }, []);

  const handleLanguageChange = (event) => {
    setSearchlang(event.target.value);
  };

  const onSelectLanguage = (languageName) => {};
  const hendleClickNo = () => {
    setPopups(false);
    setFetchTransList([]);
    setModuleName("");
    setModulemainName("");
    setLangHad("");
    setModulescreenName("");
  };

  //// ASC DropDown open and Close ByArrow Start ////
  //// (Please do not make any other code here under this function) ////
  const [open1, setOpen1] = useState(true);

  const openCloseByArrow1 = () => {
    // setOpen1((prev) => !prev);
    setOpen1(!open1);
    handleOpenClose1();
    setTouched(true);
  };

  const handleOpenClose1 = () => {
    if (open1) {
      setShowStatusDrop(true);
    } else {
      setShowStatusDrop(false);
    }
  };

  useEffect(() => {
    if (fetchCompanyList.length > 0) {
      const findIndex = fetchCompanyList.indexOf(
        (company) => company.companyname === "Spire Essentials",
      );
      setRelationship(
        findIndex === -1
          ? fetchCompanyList[0]?.companyname
          : fetchCompanyList[findIndex]?.companyname,
      );
      setModuleName(
        findIndex === -1
          ? fetchCompanyList[0]?.companyname
          : fetchCompanyList[findIndex]?.companyname,
      );
      setCompanyid(
        findIndex === -1
          ? fetchCompanyList[0]?.companyid
          : fetchCompanyList[findIndex]?.companyid,
      );
    }
  }, [fetchCompanyList]);
  //// (Please do not make any other code here under this function) ////
  //// ASC DropDown open and Close ByArrow End ////

  return (
    <>
      <div className="setting-page-outer">
        <div>
          <Header setQuery={setQuery} reRenderTranslate={reRenderTranslate} />
          <div style={{ paddingRight: "10px" }}>
            {/* {warn && (
            <Warningpopup setMovenotymsg={setWarn} msg={msg} iconn={iconn} setting={setting} />
          )} */}
          </div>
        </div>

        <div
          style={{
            paddingBottom: "50px",
          }}
          className="container-fluid"
        >
          {/* {popups && <PopupWarn msge={msges} setpop={setPopups} />} */}
          <Row className="me-md-1 mx-lg-0 mx-xl-0">
            <Col xl={8} lg={8} md={6} sm={12} className=" ps-xl-0 ">
              <p className="mt-2 setting-title">
                {/* Translations */}
                {t("Translations")}
              </p>
            </Col>
            <Col xl={4} lg={4} md={6} sm={12} className="add-col-item ">
              <div
                className={`d-flex cancel_cont_btn ${
                  moduleName == "" ||
                  modulemainName == "" ||
                  modulescreenName == "" ||
                  langHad == ""
                    ? "disabled-custom-bt--n"
                    : ""
                }`}
                // onClick={handelCancels}
                onClick={() => {
                  history.goBack();
                }}
              >
                <p className="mb-0">
                  {/* Cancel */}
                  {t("Cancel ")}
                </p>
              </div>

              <div
                className={`d-flex add-buttons ms-4 ${
                  moduleName == "" ||
                  modulemainName == "" ||
                  modulescreenName == "" ||
                  langHad == ""
                    ? "disabled-custom-btn"
                    : ""
                }`}
                onClick={handleUpdate}
              >
                <p className="fw-bold mb-0">
                  {/* Change */}
                  {t("Change")}
                </p>
              </div>
            </Col>
          </Row>
          <div
            className="px-3 my-2 tableHeight"
            style={{
              backgroundColor: "white",
              boxShadow: "3px 5px 10px #204A1B14",
              marginRight: "10px",
              overflowY: "auto",
              borderRadius: "8px",
            }}
          >
            <table className="mt-2 table table-responsive">
              <thead
                className="tblheadertext"
                style={{ borderBottom: "transparent" }}
              >
                <tr className="row">
                  <th className="col-md-4 col-lg-4 col-xl-3 col-xxl-3">
                    <p className="drp_font">{t("For Company")}</p>
                    {fetchCompanyList.length > 0 &&
                    fetchCompanyList.length > 1 ? (
                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <div
                          ref={refTypeDropDownContainerExclude}
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                          onClick={() => {
                            // setShowStatusDrop(!showStatusDrop);
                            setTouched(true);
                          }}
                        >
                          <p
                            className="margin-0 drp_header"
                            style={{
                              // marginLeft: "3px",
                              color: "#333333",
                              flexGrow: "1",
                              textTransform: "capitalize",
                              wordBreak: "break-word",
                              width: "clamp(100px, 5.208vw, 5.208vw)",
                              fontWeight: "400",
                            }}
                          >
                            {/* {moduleName || screenTranslations[12]?.translation} */}
                            {companyname || t("Select Company")}
                          </p>
                          {closeone ? (
                            <i
                              class="bi bi-x fw-bold resetCross pointer"
                              onClick={() => {
                                setCloseone(false);
                              }}
                            ></i>
                          ) : (
                            <BsChevronDown
                              size={10}
                              style={{
                                cursor: "pointer",
                                marginTop: "5px",
                                flexGlow: "1",
                                color: "#333333",
                                display: "none",
                              }}
                              // onClick={() => setShowStatusDrop(!showStatusDrop)}
                              onClick={openCloseByArrow1}
                              className={`${
                                showStatusDrop
                                  ? "down-arrow down-arrow-rotate bi-paperclip"
                                  : "down-arrow bi-paperclip"
                              }`}
                            />
                          )}
                        </div>
                        {showStatusDrop && (
                          <div
                            className="drop-down-noti-set"
                            style={{
                              minWidth: "100%",
                              height: "200px",
                              overflow: "auto",
                            }}
                            id="lang-drop-down"
                            ref={refTypeDropDownContainer}
                          >
                            {fetchCompanyList
                              ?.filter((x) => Boolean(x.companyname))
                              .map((item, i) => {
                                return (
                                  <div
                                    className={
                                      item.companyname === relationship
                                        ? " typ-list-select typ-list mt-1"
                                        : "typ-list mt-1"
                                    }
                                    // className=''
                                  >
                                    <p
                                      key={i}
                                      className="margin-0 ms-3 pb-1 mt-2"
                                      style={{
                                        opacity: 1,
                                        fontSize: "clamp(14px, .729vw, .729vw)",
                                        color: "#333333",
                                        fontWeight: 400,
                                      }}
                                      onClick={() => {
                                        // setStatusId(item.id);
                                        setRelationship(item.companyname);
                                        // setChangeComp(item?.companyname);
                                        setShowStatusDrop(false);
                                        setCloseone(true);
                                        setModuleName(item.companyname);
                                        setCompanyid(item.companyid);
                                      }}
                                    >
                                      {item.companyname}
                                    </p>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    ) : (
                      <p
                        className="margin-0 drp_header"
                        style={{
                          // marginLeft: "3px",
                          color: "#333333",
                          flexGrow: "1",
                          textTransform: "capitalize",
                          wordBreak: "break-word",
                          width: "clamp(100px, 5.208vw, 5.208vw)",
                          fontWeight: "400",
                        }}
                      >
                        {moduleName}
                      </p>
                    )}
                  </th>

                  <th className="col-md-4 col-lg-4 col-xl-3 col-xxl-3 ms-md- ms-lg-0">
                    <p className="drp_font">{t("Module")}</p>
                    <div
                      style={{
                        // cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        ref={refTypeDropDownContainer1Exclude}
                        onClick={() => {
                          setShowStatusDrop2(!showStatusDrop2);
                          setTouched(true);
                        }}
                      >
                        <p
                          className="margin-0 drp_header"
                          style={{
                            // marginLeft: "3px",
                            color: "#333333",
                            flexGrow: "1",
                            textTransform: "capitalize",
                            wordBreak: "break-word",
                            width: "clamp(100px, 5.208vw, 5.208vw)",
                          }}
                        >
                          {modulemainName ? modulemainName : t("Select Module")}
                        </p>
                        <BsChevronDown
                          size={10}
                          style={{
                            cursor: "pointer",
                            marginTop: "5px",
                            flexGlow: "1",
                            color: "#333333",
                          }}
                          className={`${
                            showStatusDrop2
                              ? "down-arrow down-arrow-rotate bi-paperclip"
                              : "down-arrow bi-paperclip"
                          }`}
                        />
                      </div>
                      {showStatusDrop2 && (
                        <div
                          className="drop-down-noti-set"
                          // style={{ width: "clamp(127px, 18vw, 18vw)" }}
                          style={{ minWidth: "100%" }}
                          id="lang-drop-down"
                          ref={refTypeDropDownContainer1}
                        >
                          {fetchModulemainList?.map((item, i) => {
                            return (
                              <div
                                className={
                                  item.modulename === relationship
                                    ? " typ-list-select typ-list"
                                    : "typ-list"
                                }
                              >
                                <p
                                  key={i}
                                  className="margin-0 ms-3 pb-1"
                                  style={{
                                    opacity: 1,
                                    fontSize: "clamp(14px, .729vw, .729vw)",
                                    color: "#333333",
                                    fontWeight: 400,
                                  }}
                                  onClick={() => {
                                    setRelationship(item.modulename);
                                    // setChangeComp(item?.modulename);
                                    setModulemainName(item.modulename);
                                    setModulescreenName("");
                                    setFetchModuleList([]);
                                    setShowStatusDrop4(false);
                                    dispatch(FetchScreenname(item?.moduleid));
                                    setShowStatusDrop2(!showStatusDrop2);
                                  }}
                                >
                                  {item.modulename}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </th>
                  <th className="col-md-4 col-lg-4 col-xl-3 col-xxl-3">
                    <p className="drp_font">{t("Screen")}</p>

                    <div
                      style={{
                        // cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <div
                        ref={refTypeDropDownContainer3Exclude}
                        onClick={() => {
                          setShowStatusDrop4(!showStatusDrop4);
                          setTouched(true);
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <p
                          className="margin-0 drp_header"
                          style={{
                            // marginLeft: "3px",
                            color: "#333333",
                            flexGrow: "1",
                            textTransform: "capitalize",
                            wordBreak: "break-word",
                            width: "clamp(100px, 5.208vw, 5.208vw)",
                          }}
                        >
                          {modulescreenName
                            ? modulescreenName
                            : t("Select Screen")}
                        </p>
                        <BsChevronDown
                          size={10}
                          style={{
                            cursor: "pointer",
                            marginTop: "5px",
                            flexGlow: "1",
                            color: "#333333",
                          }}
                          className={`${
                            showStatusDrop4
                              ? "down-arrow down-arrow-rotate bi-paperclip"
                              : "down-arrow bi-paperclip"
                          }`}
                        />
                      </div>
                      {showStatusDrop4 && (
                        <div
                          className="drop-down-noti-set"
                          // style={{ width: "clamp(127px, 18vw, 18vw)" }}
                          style={{ minWidth: "100%" }}
                          id="lang-drop-down"
                          ref={refTypeDropDownContainer3}
                        >
                          {fetchModuleList?.map((item, i) => {
                            return (
                              <div
                                className={
                                  item.value === relationship
                                    ? "hover-module typ-list-select typ-list"
                                    : " hover-module typ-list"
                                }
                                style={{
                                  backgroundColor:
                                    modulescreenName === item.screenname
                                      ? "#F4F5F4"
                                      : "transparent",
                                }}
                                // className=''
                              >
                                <p
                                  key={i}
                                  className="margin-0 ms-3 pb-1"
                                  style={{
                                    opacity: 1,
                                    // fontSize: "clamp(14px, .729vw, .729vw)",
                                    color: "#333333",
                                    fontWeight: 400,
                                  }}
                                  onClick={() => {
                                    setModulescreenName(item.screenname);
                                    setRelationship(item.screenname);
                                    // setChangeComp(item?.screenname);
                                    setShowStatusDrop4(!showStatusDrop4);
                                  }}
                                >
                                  {item.screenname}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </th>
                  <th className="col-md-4 col-lg-4 col-xl-3 col-xxl-3 ms-md- ms-lg-0">
                    <p className="drp_font">{t("Language")}</p>

                    <div
                      style={{
                        position: "relative",
                        // cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        onClick={() => {
                          setShowStatusDrop3(!showStatusDrop3);
                          setTouched(true);
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        ref={refTypeDropDownContainer2Exclude}
                      >
                        <p
                          className="margin-0 Client-input-service drp_header"
                          style={{
                            color: "#444141",
                            fontsize: "14px",
                            wordBreak: "break-word",
                            width: "clamp(197px, 13vw, 13vw)",
                          }}
                        >
                          {/* {(jobname && `${client?.contactname}`) ||
                                    "Select a client"} */}

                          {langHad ? langHad : t("Select destination language")}
                        </p>
                        <BsChevronDown
                          size={10}
                          style={{
                            cursor: "pointer",
                            marginTop: "5px",
                            flexGlow: "1",
                            color: "#333333",
                          }}
                          className={`${
                            showStatusDrop3
                              ? "down-arrow down-arrow-rotate bi-paperclip"
                              : "down-arrow bi-paperclip"
                          }`}
                        />
                      </div>
                      {showStatusDrop3 && (
                        <div
                          className="client-drop-servic-lang"
                          style={{
                            minWidth: "100%",
                          }}
                          ref={refTypeDropDownContainer2}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() => {
                              setShowStatusDrop3(false);
                            }}
                          ></div>

                          <div className="client-searching">
                            <input
                              type="text"
                              value={searchlang}
                              style={{
                                margin: "0 0 0 0rem",
                                opacity: "0.5",
                                borderBottom: "1px solid #A5A5A5",
                                color: "#A5A5A5",
                                width: "100%",
                                fontsize: "14px",
                                fontWeight: searchlang ? "400" : "300",
                              }}
                              placeholder="Search"
                              className="search-style select-client-div"
                              onChange={(e) => {
                                setSearchlang(e.target.value);
                              }}
                            />
                          </div>
                          {searchlang !== "" && (
                            <div
                              style={{
                                height: "50px",
                                overflow: "auto",
                                backgroundColor: "rgb(221 234 241)",
                              }}
                            >
                              {filteredLanguages
                                ?.filter(
                                  (sourceItem) =>
                                    !fetchLanguageList.some(
                                      (removeItem) =>
                                        sourceItem.name ===
                                        removeItem.languagename,
                                    ),
                                )
                                ?.map((language, i) => (
                                  <p
                                    key={i}
                                    className="mb-0 drp_header"
                                    onClick={() => {
                                      dispatch(
                                        createTranslation(
                                          userId,
                                          language.name,
                                          language.code,
                                        ),
                                      );
                                      setCreatedlangnames(language.name);
                                      setLangHad(language.name);
                                      setShowStatusDrop3(!showStatusDrop3);
                                      setSearchlang("");
                                      setPerPage(10);
                                      // setPaddingCol(false);
                                    }}
                                  >
                                    {language.name}
                                  </p>
                                ))}
                            </div>
                          )}
                          <div className="service-list-hieght">
                            {fetchLanguageList
                              // ?.data
                              //                 ?.filter((data) =>
                              //                   data?.managername
                              //                     ?.toLowerCase()
                              //                     .includes(
                              //                       clientSearch?.toLowerCase()
                              //                     )
                              //                 )
                              .map((project, i) => {
                                return (
                                  <>
                                    <div className="d-flex pt-2 pb-1">
                                      <p
                                        className="margin-0 drp_header"
                                        key={i}
                                        style={{
                                          textTransform: "capitalize",
                                        }}
                                        onClick={() => {
                                          // let listcontactid = project?.id;
                                          // let contactname = project?.name;
                                          // let contacttype = project?.type;
                                          // setAccountManagerId(
                                          //   project?.managerid
                                          // );
                                          // setJobname(
                                          //   project?.managername
                                          // );
                                          // setChangeComp(
                                          //   project?.managername
                                          // );
                                          setLangHad(project?.languagename);
                                          setShowStatusDrop3(false);
                                          setShowAdditionalSetting(true);
                                          setPerPage(10);
                                        }}
                                      >
                                        {project?.languagename}
                                      </p>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>
                      )}
                    </div>
                  </th>
                </tr>
              </thead>
            </table>

            {(moduleName && langHad) || createdlangnames ? (
              <table
                className="table mt-3 setting-page-table"
                style={{
                  minWidth: "900px",
                }}
              >
                <tbody>
                  {fetchTransList.map((val, index) => {
                    // setComp(val.translation);
                    // let transid = val.translationid;
                    // setTranslateId(transid);
                    return (
                      <div
                        style={{
                          borderTop: "#a5a5a5 dashed 1px",
                        }}
                        className="dash-border-content"
                      >
                        <tr
                          style={{
                            border: "none",
                          }}
                          key={index}
                          className="row"
                        >
                          <td className="col-0 col-xl-4 p-0 col-lg-4 "></td>
                          <td
                            style={{
                              filter: `${
                                val.translation === ""
                                  ? // ? `opacity(50%)`
                                    `opacity(100%)`
                                  : `opacity(100%)`
                              }`,
                              fontWeight: `${
                                val.translation === "" ? "400" : "700"
                              }`,
                              color: "#333333",
                              fontSize: "clamp(14px, 0.729vw, 1.025vw)",
                            }}
                            className="col-2 col-md-3"
                            // className="col-2 col-md-3 language-text"
                          >
                            {val?.fieldname}
                          </td>
                          <td
                            className="col-2 col-md-1"
                            style={{ paddingLeft: "42px" }}
                          >
                            <img
                              style={{
                                filter: `${
                                  val.translation === ""
                                    ? `opacity(50%)`
                                    : `opacity(100%)`
                                }`,
                              }}
                              src={trans_icon}
                              alt="->"
                            />
                          </td>
                          <td className="col-5 col-xl-4 col-lg-4 inp_name">
                            {/* <input
                            type="text"
                            className="language-text"
                            value={val.translation}
                            onChange={(e) => {
                              handleInputChange(e, val.translationid);
                              setChangeComp(e.target.value);
                            }}
                          /> */}
                            <textarea
                              className="language-text custom-text-area"
                              value={val.translation}
                              onChange={(e) => {
                                handleInputChange(e, val.translationid);
                                setChangeComp(e.target.value);
                              }}
                              onInput={(e) => updateTextareaHeight(e.target)}
                            >
                              {" "}
                            </textarea>
                          </td>
                          {/* <td className="col-4">{transName}</td> */}
                        </tr>
                      </div>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="default-dash-container">
                {new Array(9).fill(1).map((_, item) => (
                  <div className="default-dash" />
                ))}
              </div>
            )}
          </div>

          {showAdditionalSetting && (
            <Row>
              <Col xl={9} md={6}>
                <p
                  className="fw-bold mt-3 "
                  style={{
                    fontSize: "20px",
                    color: "#333333",
                    display: "flex",
                  }}
                >
                  <p
                    className="table-item mt-1 item-per-page"
                    style={{
                      fontWeight: 400,
                      marginLeft: "14px",
                    }}
                  >
                    {/* Items per page */}
                    {t("Item per page ")}
                  </p>
                  {/* <select
                    value={perPage}
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                    }}
                    className="Items-per-page ms-3 fw-bold"
                  >
                    {[10, 20, 50].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select> */}
                  <div
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "5px",
                    }}
                    className="ms-4"
                  >
                    <p
                      className="margin-0 selected-item-number"
                      style={{
                        fontWeight: "bold",
                        color: "#333333",
                        flexGrow: "1",
                        textTransform: "capitalize",
                      }}
                      onClick={() => setShowMemberItem(!showMemberItem)}
                    >
                      {perPage}
                    </p>
                    <BsChevronDown
                      size={10}
                      style={{
                        flexGlow: "1",
                        color: "#333333",
                      }}
                      onClick={() => setShowMemberItem(!showMemberItem)}
                      className="down-arrow bi-paperclip ms-2 mt-1"
                    />
                    {showMemberItem && (
                      <div
                        className="drop-down-member-item d-flex align-items-end p-1"
                        ref={refTypeDropDownContainer}
                        id="lang-drop-down"
                      >
                        <div>
                          {[10, 20, 50]?.map((item, i) => {
                            return (
                              <div>
                                <p
                                  key={i}
                                  className="margin-0 ms-2 pb-1 item-per-page-number"
                                  style={{
                                    opacity: 1,
                                    fontWeight: "bold",
                                    color: `${
                                      item === perPage ? "#95A7C6" : "#333333"
                                    }`,
                                  }}
                                  onClick={() => {
                                    setPerPage(item);
                                    const totalPages2 = Math.ceil(
                                      fetchTranslationDatas?.data?.data
                                        ?.length / item,
                                    );
                                    setTotalPages(totalPages2);
                                    setCurrentPage(0);
                                    if (fetchTranslationDatas?.data?.data) {
                                      setFetchTransList(
                                        fetchTranslationDatas?.data?.data?.slice(
                                          0,
                                          item,
                                        ),
                                      );
                                    }
                                    setShowMemberItem(false);
                                  }}
                                >
                                  {item}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                        <BsChevronDown
                          size={10}
                          style={{
                            fontWeight: "bold",
                            flexGlow: "1",
                            color: "#333333",
                          }}
                          className="mb-1 ms-1 down-arrow down-arrow-rotate bi-paperclip"
                        />
                      </div>
                    )}
                  </div>
                </p>
              </Col>
              <Col xl={3} md={6} className="add-col-item">
                <div className="table-filter-info">
                  <ReactPaginate
                    nextLabel=""
                    forcePage={currentPage}
                    disableInitialCallback={true}
                    onPageChange={PaginationChange}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={totalPages}
                    previousLabel=""
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="d-none"
                    nextClassName="d-none"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="app-paginations"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                </div>
              </Col>
            </Row>
          )}
        </div>
        <InfoSaveOrNotPopup
          show={popups}
          hendleClickNo={hendleClickNo}
          setPopups={setPopups}
        />
      </div>
      <RouteLeavingGuard
        when={touched}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (touched) {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
    </>
  );
};

export default Settings;
